module.exports = __webpack_public_path__ + "static/media/atletismo.33078735.webp";